var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.7707 11.1047L8.94202 13.9334C8.69201 14.1831 8.35307 14.3234 7.99968 14.3234C7.6463 14.3234 7.30736 14.1831 7.05735 13.9334L4.22802 11.1047C3.48217 10.3588 2.97424 9.40852 2.76848 8.37396C2.56271 7.3394 2.66834 6.26706 3.07202 5.29254C3.4757 4.31801 4.15928 3.48508 5.03634 2.89905C5.9134 2.31303 6.94453 2.00024 7.99935 2.00024C9.05417 2.00024 10.0853 2.31303 10.9624 2.89905C11.8394 3.48508 12.523 4.31801 12.9267 5.29254C13.3304 6.26706 13.436 7.3394 13.2302 8.37396C13.0245 9.40852 12.5165 10.3588 11.7707 11.1047Z",
  fill: "#94B4A4"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8 9.33325C9.10457 9.33325 10 8.43782 10 7.33325C10 6.22868 9.10457 5.33325 8 5.33325C6.89543 5.33325 6 6.22868 6 7.33325C6 8.43782 6.89543 9.33325 8 9.33325Z",
  fill: "white"
});

function SvgLocationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.7b2eab54aa87ecfac07ff05146dbc171.svg";
export { ForwardRef as ReactComponent };